import { motion } from "motion/react";
import { Box, Skeleton } from "@mui/material";
import React from "react";
import { Flex } from "~/components/Flex";

export const RemediationDropdownsSkeleton = () => {
  return (
    <Flex gap={3}>
      <Box
        component={motion.div}
        width="100%"
        key="skeleton-title"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        sx={{
          height: 56,
          p: 0,
          m: 0,
          bgcolor: "code.background",
          borderRadius: 1,
          overflow: "hidden",
        }}
      >
        <Skeleton animation="wave" variant="rectangular" height={56} />
      </Box>
      <Box
        component={motion.div}
        width="100%"
        key="skeleton-version"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        sx={{
          height: 56,
          p: 0,
          m: 0,
          bgcolor: "code.background",
          borderRadius: 1,
          overflow: "hidden",
        }}
      >
        <Skeleton animation="wave" variant="rectangular" height={56} />
      </Box>
    </Flex>
  );
};
